export default __webpack_public_path__ + "static/media/attendIcon.dd278cf9.png";